/*** IMPORTS FROM imports-loader ***/
var define = false;

import each from 'lodash/each'
import get from 'lodash/get'
import map from 'lodash/map'
import objectFitImages from 'object-fit-images'
import $ from 'jquery'
import 'slick-carousel'
import PhotoSwipeUiDefault from 'photoswipe/dist/photoswipe-ui-default'
import PhotoSwipe from 'photoswipe'
import eventBus from '../../eventBus'

export default {
  // language=HTML (for PhpStorm)
  template: `
    <div class="photo-gallery" :id="elId">
      <template v-if="isGrid">
        <div class="row flush half-gutter with-vertical-gutter" :class="gridClassObject">
          <div v-for="(photo, photoIdx) in photos" class="column js-cms-photo-gallery-item">
            <a
              @click.prevent="openGridPhoto(photo)"
              :href="photoBaseUrl + photo.path"
              :aria-label="getAriaLabel(photo, photoIdx)"
            ><img
              class="js-gallery-image"
              :src="photoBaseUrl + photo.dir + '_thumb/' + photo.filename"
              alt=""></a>
          </div>
        </div>
      </template>
      <template v-else-if="isCarousel">
        <div ref="bigSlides" class="big-slides" :class="bigSlidesClassObject">
          <button
            v-for="(photo, photoIdx) in photos"
            :key="photo.id"
            type="button" class="slide"
            :aria-label="'Enlarge photo #' + (photoIdx + 1)"
          >
            <img :data-lazy="photoBaseUrl + photo.dir + photo.filename" alt="" />
          </button>
        </div>
        <div ref="thumbSlides" v-if="photos.length > 1" class="thumb-slides" :class="thumbSlidesClassObject">
          <button
            v-for="(photo, photoIdx) in photos"
            :key="photo.id"
            type="button" class="slide"
            :aria-label="'View photo #' + (photoIdx + 1)"
          >
            <span class="image-window" :style="getThumbSlideStyle(photo)"></span>
          </button>
        </div>
      </template>
    </div>
  `,
  props: {
    id: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: true,
      validator(value) {
        return ['carousel', 'grid', 'lightbox'].indexOf(value) !== -1
      },
    },
    gridClasses: {
      type: Array,
    },
    carouselThumbSlidesToShow: {
      type: Object,
      required: true,
    },
    photos: {
      type: Array,
      required: true,
      default() {
        return []
      },
    },
    photoBaseUrl: {
      type: String,
      default: window.APP.context.site.files_url,
    },
  },
  computed: {
    elId() {
      if (this.isLightbox) {
        return `lightbox-${this.id}`
      }
      return this.id
    },
    isGrid() {
      return this.mode === 'grid'
    },
    isCarousel() {
      return this.mode === 'carousel'
    },
    isLightbox() {
      return this.mode === 'lightbox'
    },
    gridClassObject() {
      const classes = {}

      each(this.gridClasses, (gridClass) => {
        classes[gridClass] = true
      })

      return classes
    },
    bigSlidesClassObject() {
      return {
        [`big-slides-${this.id}`]: true,
      }
    },
    thumbSlidesClassObject() {
      return {
        [`thumb-slides-${this.id}`]: true,
      }
    },
    photoswipePhotos() {
      return map(this.photos, photo => ({
        src: this.photoBaseUrl + photo.path,
        w: photo.width,
        h: photo.height,
        title: photo.title,
        description: photo.description,
      }))
    },
  },
  methods: {
    getAriaLabel(photo, photoIdx) {
      return get(photo, 'title', `View Photo #${photoIdx + 1}`)
    },
    getThumbSlideStyle(photo) {
      return {
        backgroundImage: `url('${this.photoBaseUrl}${photo.dir}_thumb/${photo.filename}')`,
      }
    },

    openGridPhoto(photo) {
      this.pswpOptions.index = this.photos.indexOf(photo)
      const gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUiDefault, this.photoswipePhotos, this.pswpOptions)
      gallery.init()
    },

    setupCarousel() {
      const bigSlidesSelector = `.big-slides-${this.id}`
      const thumbSlidesSelector = `.thumb-slides-${this.id}`

      const opts = {
        infinite: true,
        lazyLoad: 'progressive',
        adaptiveHeight: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
      }

      if (this.$refs.thumbSlides) {
        opts.asNavFor = thumbSlidesSelector
      }

      $(this.$refs.bigSlides).slick(opts)

      $(this.$refs.bigSlides).on('click', '.slide', (ev) => {
        ev.preventDefault()
        this.pswpOptions.index = $(ev.currentTarget).closest('.slick-slide').data('slick-index')
        const gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUiDefault, this.photoswipePhotos, this.pswpOptions)
        gallery.init()
      })

      if (this.$refs.thumbSlides) {
        const responsive = []
        each(this.carouselThumbSlidesToShow.breakpoints, (breakpoint) => {
          responsive.push({
            breakpoint: breakpoint.breakpoint,
            settings: {
              arrows: breakpoint.breakpoint >= 768,
              centerMode: true,
              centerPadding: '60px',
              slidesToShow: breakpoint.slides,
              slidesToScroll: breakpoint.slides,
            },
          })
        })

        $(this.$refs.thumbSlides).slick({
          asNavFor: bigSlidesSelector,
          focusOnSelect: true,
          infinite: true,
          speed: 300,
          slidesToShow: this.carouselThumbSlidesToShow.default,
          slidesToScroll: this.carouselThumbSlidesToShow.default,
          prevArrow: $('#slider-prev').html(),
          nextArrow: $('#slider-next').html(),
          centerMode: false,
          mobileFirst: true,
          arrows: false, // mobile-only. overridden by responsive settings
          responsive,
        })

        $(this.$refs.thumbSlides).on('click', '.slide', (ev) => {
          $(this.$refs.thumbSlides).slick('slickGoTo', $(ev.currentTarget).closest('.slick-slide').data('slick-index'))
        })
      }
    },

    handleOpenLightbox(galleryId) {
      const actualGalleryId = galleryId.replace(/^#lightbox-/g, '')

      if (actualGalleryId !== this.id || !this.isLightbox) {
        return
      }

      this.pswpOptions.index = 0
      const gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUiDefault, this.photoswipePhotos, this.pswpOptions)
      gallery.init()
    },
  },

  created() {
    this.pswpElement = document.querySelectorAll('.pswp')[0]

    this.pswpOptions = {
      galleryUID: 1,
      index: 0,
      bgOpacity: 1,
      captionEl: true,
      fullscreenEl: false,
      shareEl: false,
      tapToClose: true,
      tapToToggleControls: false,
      addCaptionHTMLFn(item, captionEl) {
        if (!item.title) {
          captionEl.children[0].innerText = ''
          return false
        }
        let html = item.title
        if (item.description) {
          html += `<br/><small>${item.description}</small>`
        }

        captionEl.children[0].innerHTML = html
        return true
      },
    }

    eventBus.$on('open-lightbox', this.handleOpenLightbox)
  },

  mounted() {
    this.$nextTick(() => {
      if (this.mode === 'carousel') {
        this.setupCarousel()
      }

      objectFitImages(document.querySelectorAll('img.js-gallery-image'))
    })
  },

  beforeDestroy() {
    eventBus.$off('open-lightbox', this.handleOpenLightbox)
  },
}

